import { createContext, useContext } from 'react';
import type { RcDialer } from './useRcDialer';

/**
 * One RingCentral dialer for the whole module — the ring card, the call log
 * and the panel itself all read this rather than each mounting a frame of
 * their own. Two frames would be two web phone registrations for one
 * RingCentral user, and the ring would fork between them.
 *
 * Null when the provider is absent, which the preview route relies on: the
 * module renders complete, minus a dialer.
 */
export const DialerContext = createContext<RcDialer | null>(null);

export const useDialer = (): RcDialer | null => useContext(DialerContext);
